// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F34b","delete":"styles_delete__1bAAh","update":"styles_update__1mvMY","add":"styles_add__DN6oU"};